module.exports = __webpack_public_path__ + "img/applepay.70f4e4e9.png";